import { api } from './api';

 
export const marketplaceApi = api.injectEndpoints({
  endpoints: (builder) => ({
    requestSubscription: builder.mutation({
      query: ({
        addonId, action, billingCycle, expiredAt,
      }) => {
        return {
          url: 'requestSubscription',
          method: 'POST',
          body: {
            addonId,
            action,
            billingCycle,
            expiredAt,
          },
        };
      },
    }),
  }),
});

export const {
  useRequestSubscriptionMutation,
} = marketplaceApi;
